import { RouteObject } from "react-router-dom";

export const ticketValidationRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Ticket Validation" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { TicketValidationPage } = await import(
            "./ticket-validation-page"
          );
          return { Component: TicketValidationPage };
        },
      },
    ],
  },
];
